import { ITimeOccurrenceDatatype, IRawTimeOccurrenceDatatype } from '../../datastore/time/data_types';

interface ITimeOccurenceAugmentedDTD {
  trackingId: string;
  group: string;
  type: string;
  isLocked: boolean;
  isWarning: boolean;
  isPreview: boolean;
  isWaitlisted: boolean;
  isRegistered: boolean;
  isSwapFrom: boolean;
  isSwapTo: boolean;
  hover: Object;
}

const TimeOccurrenceDatatype: IRawTimeOccurrenceDatatype & ITimeOccurenceAugmentedDTD = {
  day_of_week: {
    required: true,
    type: 'ordinal',
    typeDef: 'DayOfTheWeekEnum',
    defaultValue: '',
    writeToKey: 'day'
  } as any as number,
  from_tm: {
    required: true,
    type: 'clock',
    writeToKey: 'from',
    rules: {
      defaultsToNow: false
    }
  } as any as string,
  to_tm: {
    required: true,
    type: 'clock',
    writeToKey: 'to',
    rules: {
      defaultsToNow: false
    }
  } as any as string,
  repeats_every: {
    type: 'integer',
    defaultValue: 1
  } as any as number,
  id: 'key',
  trackingId: 'auto-id' as any as string,
  beginMinutes: 'integer' as any as number,
  endMinutes: 'integer' as any as number,
  bkgColorClass: 'string',
  content: 'string',
  appId: '*',
  group: 'string',
  type: 'string',
  isLocked: 'boolean' as any as boolean,
  isWarning: 'boolean' as any as boolean,
  isPreview: 'boolean' as any as boolean,
  isWaitlisted: 'boolean' as any as boolean,
  isRegistered: 'boolean' as any as boolean,
  isSwapFrom: 'boolean' as any as boolean,
  isSwapTo: 'boolean' as any as boolean,
  icons: {
    type: 'array',
    typeDef: 'string'
  } as any as Array<string>,
  hover: 'object'
};

angular
  .module('ui-ng-calendar')
  .constant('TimeOccurrenceDTD', TimeOccurrenceDatatype)
  .factory('TimeOccurrenceBuilder', function (Interface: any, TimeOccurrenceDTD: ITimeOccurrenceDatatype) {
    return function TimeOccurrenceDTO(obj: IRawTimeOccurrenceDatatype): ITimeOccurrenceDatatype {
      // TECHDEBT: Whats the best way here to make this a class?
      let DTO: any = {};
      DTO = Interface.implement(TimeOccurrenceDTD, obj, DTO);

      DTO.fromMinutes = DTO.from.hour() * 60 + DTO.from.minute();
      DTO.toMinutes = DTO.to.hour() * 60 + DTO.to.minute();

      DTO.fromInput = DTO.from.format('HH:mm:ss');
      DTO.toInput = DTO.to.format('HH:mm:ss');
      return DTO;
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/builders/time/time_occurrence_builder.ts